import Vue from "vue";
import Vuex from "vuex";
import api from "./services/api";
import { dateFormatNames } from "@telerik/kendo-intl";

Vue.use(Vuex);

const defaultSettings = {
	alarms: {
		viewType: "map",
		useReverseGeocoding: false
	},
	canExportGridData: false,
	defaultPageSize: 25,
	mobility_manager_email: "",
	show_phone_in_map: false,
	diagnosis: {
		viewType: "map",
		useReverseGeocoding: false
	},
	geoLocation: {
		refreshInterval: 300,
		viewType: "map"
	},
	maps: {
		mapType: "google",
		apiKey: ""
	},
	trips: {
		viewType: "map"
	},
	hasDivisions: false,
	viewPoi: false,
	viewSatellite: false,
	viewTraffic: false,
	vehicleIdFilterField: "number_plate",
	commonLabels: []
};

const menuLabels = [];

const scopes = [];
const roles = [];

const ACCOUNT = "account";
const LOGIN_SUCCESS = "login_success";
const SET_SCOPES = "set_scopes";
const SET_ROLES = "set_roles";
const LOGOUT = "logout";
const SETTINGS = "settings";
const SETTINGS_FLEERUN = "settingsFleeRun";
const SETTINGS_MENU_LABELS = "settingsMenuLabels";

const store = new Vuex.Store({
	state: {
		user: {
			company: {}
		},
		isLoggedIn: !!localStorage.getItem("fr-token"),
		settings: localStorage.getItem("settings") ? JSON.parse(localStorage.getItem("settings")) : defaultSettings,
		menuLabels: localStorage.getItem("menuLabels") ? JSON.parse(localStorage.getItem("menuLabels")) : menuLabels,
		scopes: localStorage.getItem("scopes") ? JSON.parse(localStorage.getItem("scopes")) : scopes,
		roles: localStorage.getItem("roles") ? JSON.parse(localStorage.getItem("roles")) : roles

		//data: localStorage.getItem("data")
	},
	getters: {
		isLoggedIn: state => {
			return state.isLoggedIn;
		},
		currentUser: state => {
			return state.user;
		},
		settings: state => {
			return state.settings;
		},
		menuLabels: state => {
			return state.menuLabels;
		},
		scopes: state => {
			return state.scopes;
		},
		roles: state => {
			return state.roles;
		}
		// data: state => {
		// 	return state.data;
		// }
	},
	mutations: {
		[LOGIN_SUCCESS](state, token) {
			localStorage.setItem("fr-token", token);
			state.isLoggedIn = true;
		},
		[SET_SCOPES](state, scopes) {
			localStorage.setItem("scopes", JSON.stringify(scopes));
			state.scopes = scopes;
		},
		[SET_ROLES](state, roles) {
			localStorage.setItem("roles", JSON.stringify(roles));
			state.roles = roles;
		},
		[LOGOUT](state, token) {
			localStorage.clear();
			state.isLoggedIn = false;
			state.settings = defaultSettings;
			state.scopes = [];
			state.user = {
				company: {}
			};
		},
		[ACCOUNT](state, user) {
			state.user = user;
		},
		[SETTINGS](state, data) {
			var commonLabels = {};
			for (var i = 0; i < data.commonLabels.length; i++) {
				var cl = data.commonLabels[i];
				var key = cl.key.replace("common.", "");
				if (key == "vehicle") key = cl.key.replace("vehicle.", "vehicleName");
				commonLabels[key] = cl.value;
			}

			var settings = {
				alarms: {
					viewType: data.alarms.viewType,
					useReverseGeocoding: data.alarms.useReverseGeocoding
				},
				canExportGridData: data.canExportGridData,
				defaultPageSize: data.defaultPageSize,
				mobility_manager_email: data.mobility_manager_email,
				show_phone_in_map: data.show_phone_in_map,
				diagnosis: {
					viewType: data.diagnosis.viewType,
					useReverseGeocoding: data.diagnosis.useReverseGeocoding
				},
				geoLocation: {
					refreshInterval: data.geoLocation.refreshInterval,
					viewType: data.geoLocation.viewType
				},
				maps: {
					mapType: data.maps.mapType,
					apiKey: data.maps.apiKey
				},
				trips: {
					viewType: data.trips.viewType,
					refreshInterval: data.trips.refreshInterval
				},
				viewPoi: data.viewPoi,
				hasDivisions: data.hasDivisions,
				viewSatellite: data.viewSatellite,
				viewTraffic: data.viewTraffic,
				vehicleIdFilterField: data.vehicleIdFilterField == "numberPlate" ? "number_plate" : "code",
				commonLabels: commonLabels
			};
			state.settings = settings;
			localStorage.setItem("settings", JSON.stringify(settings));
		},
		[SETTINGS_FLEERUN](state, data) {
			var settings = {
				alarms: {
					viewType: data.alarms ? data.alarms.viewType : state.settings.alarms.viewType,
					useReverseGeocoding: state.settings.alarms.useReverseGeocoding
				},
				diagnosis: {
					viewType: data.diagnosis ? data.diagnosis.viewType : state.settings.diagnosis.viewType,
					useReverseGeocoding: state.settings.diagnosis.useReverseGeocoding
				},
				geoLocation: {
					refreshInterval: data.geoLocation && data.geoLocation.refreshInterval ? data.geoLocation.refreshInterval : state.settings.geoLocation.refreshInterval,
					viewType: data.geoLocation && data.geoLocation.viewType ? data.geoLocation.viewType : state.settings.geoLocation.viewType
				},
				trips: {
					viewType: data.trips ? data.trips.viewType : state.settings.trips.viewType,
					refreshInterval: state.settings.trips.refreshInterval
				},

				//external settings
				maps: {
					mapType: state.settings.maps.mapType,
					apiKey: state.settings.maps.apiKey
				},
				viewPoi: state.settings.viewPoi,
				hasDivisions: state.settings.hasDivisions,
				viewSatellite: state.settings.viewSatellite,
				viewTraffic: state.settings.viewTraffic,
				canExportGridData: state.settings.canExportGridData,
				defaultPageSize: state.settings.defaultPageSize,
				commonLabels: state.settings.commonLabels,
				vehicleIdFilterField: state.settings.vehicleIdFilterField,
				mobility_manager_email: data.mobility_manager_email,
				show_phone_in_map: state.settings.show_phone_in_map
			};
			state.settings = settings;
			localStorage.setItem("settings", JSON.stringify(settings));
		},
		[SETTINGS_MENU_LABELS](state, data) {
			var menuLabels = {};
			for (var i = 0; i < data.length; i++) {
				for (var c = 0; c < data[i].childs.length; c++) {
					var child = data[i].childs[c];
					var key = child.label_code;
					menuLabels[key] = child.label;
				}
			}

			state.menuLabels = menuLabels;
			localStorage.setItem("menuLabels", JSON.stringify(menuLabels));
		}
	},
	actions: {
		login({ state, commit, rootState }, creds) {
			return new Promise((resolve, reject) => {
				api.login(creds.company, creds.userName, creds.password, creds.token).then(
					res => {
						commit(LOGIN_SUCCESS, res.data.token);
						commit(SET_SCOPES, res.data.scopes);
						commit(SET_ROLES, res.data.roles);
						resolve();
					},
					error => {
						reject(error);
					}
				);
			});
		},
		loginAAD({ state, commit, rootState }, data) {
			return new Promise((resolve, reject) => {
				api.loginAAD(data.company, data.token).then(
					res => {
						commit(LOGIN_SUCCESS, res.data.token);
						commit(SET_SCOPES, res.data.scopes);
						commit(SET_ROLES, res.data.roles);
						resolve();
					},
					error => {
						reject(error);
					}
				);
			});
		},
		verify({ state, commit, rootState }, creds) {
			return new Promise((resolve, reject) => {
				api.verify(creds.company, creds.userName, creds.oneTimePassword).then(
					res => {
						commit(LOGIN_SUCCESS, res.data.token);
						commit(SET_SCOPES, res.data.scopes);
						commit(SET_ROLES, res.data.roles);
						resolve();
					},
					error => {
						reject(error);
					}
				);
			});
		},
		logout({ commit }) {
			return new Promise(resolve => {
				localStorage.removeItem("fr-token");
				commit(LOGOUT);
				resolve();
			});
		},
		me({ commit }) {
			return new Promise(resolve => {
				api.getMyAccount().then(
					res => {
						commit(ACCOUNT, res.data);
						resolve();
					},
					error => {
						console.log(error);
					}
				);
			});
		}
	},
	modules: {}
});

class FleerunStore {
	constructor() {
		this.store = store;
	}
}

export default new FleerunStore();
